var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 14.375C12.2625 14.375 12.9938 14.0721 13.5329 13.5329C14.0721 12.9938 14.375 12.2625 14.375 11.5C14.375 10.7375 14.0721 10.0062 13.5329 9.46707C12.9938 8.9279 12.2625 8.625 11.5 8.625C10.7375 8.625 10.0062 8.9279 9.46707 9.46707C8.9279 10.0062 8.625 10.7375 8.625 11.5C8.625 12.2625 8.9279 12.9938 9.46707 13.5329C10.0062 14.0721 10.7375 14.375 11.5 14.375V14.375Z",
    stroke: "#2C54E2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.91797 12.3433V10.6566C1.91797 9.65996 2.73255 8.83579 3.7388 8.83579C5.47339 8.83579 6.18255 7.60913 5.31047 6.10454C4.81214 5.24204 5.10922 4.12079 5.9813 3.62246L7.63922 2.67371C8.3963 2.22329 9.3738 2.49163 9.82422 3.24871L9.92964 3.43079C10.7921 4.93538 12.2105 4.93538 13.0826 3.43079L13.188 3.24871C13.6384 2.49163 14.6159 2.22329 15.373 2.67371L17.0309 3.62246C17.903 4.12079 18.2001 5.24204 17.7017 6.10454C16.8296 7.60913 17.5388 8.83579 19.2734 8.83579C20.2701 8.83579 21.0942 9.65038 21.0942 10.6566V12.3433C21.0942 13.34 20.2796 14.1641 19.2734 14.1641C17.5388 14.1641 16.8296 15.3908 17.7017 16.8954C18.2001 17.7675 17.903 18.8791 17.0309 19.3775L15.373 20.3262C14.6159 20.7766 13.6384 20.5083 13.188 19.7512L13.0826 19.5691C12.2201 18.0645 10.8017 18.0645 9.92964 19.5691L9.82422 19.7512C9.3738 20.5083 8.3963 20.7766 7.63922 20.3262L5.9813 19.3775C5.56356 19.1369 5.25832 18.7405 5.13255 18.2752C5.00678 17.8098 5.07077 17.3136 5.31047 16.8954C6.18255 15.3908 5.47339 14.1641 3.7388 14.1641C2.73255 14.1641 1.91797 13.34 1.91797 12.3433V12.3433Z",
    stroke: "#2C54E2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.528ff529c6b5d8cb4d07afcc4b9b8002.svg";
export { ForwardRef as ReactComponent };